import React, { forwardRef } from 'react';

import CardM, { CardProps as CardPropsM } from '@mui/material/Card';

export interface CardProps extends CardPropsM {
  /**
   * The content of the component.
   */
  children?: React.ReactNode;
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: CardPropsM['classes'];
  /**
   * If true, the card will use raised styling.
   */
  raised?: boolean;
  /**
   * If true, the card will have styles for variant "selected"
   */
  selected?: boolean;
  /**
   * If disabled, the card will have styles for variant "disabled"
   */
  disabled?: boolean;
  /**
   * If true, the card will have styles for variant "warning"
   */
  warning?: boolean;
  /**
   * If error, the card will have styles for variant "error"
   */
  error?: boolean;
  /**
   * If ai, the card will have styles for variant "ai"
   */
  ai?: boolean;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: CardPropsM['sx'];
  /**
   * If true, the card will have no hover state and no possibility for user to select the card"
   */
  readOnly?: boolean;
  /**
   * Card hover shadow variant
   */
  hoverShadow?:
    | 'hoverSmall'
    | 'hoverMedium'
    | 'hoverBig'
    | 'noHover'
    | 'default';
}

/**
 * @deprecated Use the new Card component from @mint-lib/tw-components instead.
 */
const Card = forwardRef(
  (props: CardProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <CardM ref={ref} {...props}>
        {props.children}
      </CardM>
    );
  },
);

export default Card;
